import moment from "moment";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import {
	TORB3BackendRecord,
	TORB3Record,
} from "../../../../../redux/app/orb3/@types";
import { TORB3GroupC4_1 } from "../../../../../redux/app/orb3/groups/group-c";
import ORB3TableRows from "../ORB3TableRows";
import CommaSeparator from "../../../../_common/CommaSeparator";
import { IStore } from "../../../../../redux/store";
import { vesselSelectors } from "redux/app/vessel";

type OwnProps = {
	orb3Record: TORB3Record | TORB3BackendRecord;
	theme?: "light" | "dark";
};
type ORB3GroupC4_1PreviewProps = OwnProps & PropsFromRedux;

function ORB3GroupC4_1Preview(props: ORB3GroupC4_1PreviewProps) {
	const record = props.orb3Record as TORB3GroupC4_1;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY",
	);
	const {
		itemC4EntryExit,
		itemC4_1P1,
		itemC4FuelTransition,
		itemC4Tanks,
		itemC4Scrubber,
	} = record;

	function renderItemP1() {
		const { date: smtDate, time: smtTime } = itemC4_1P1;
		const dateTimeLocal = `${smtDate}T${smtTime}:00${record.timeZone}`;
		const utcTime = moment.utc(dateTimeLocal);
		return (
			<h4 className="font-medium uppercase">
				Commencement of{" "}
				<CommaSeparator
					items={itemC4FuelTransition.equipmentsUsed.map((equipment) =>
						equipment.split("_").join(" "),
					)}
					lastItemSeperator={" & "}
				/>{" "}
				Bunker Change Over upon {itemC4EntryExit.entryOrExit} SECA on{" "}
				{utcTime.format("HH:mm")} hrs UTC, {utcTime.format("DD-MMM-YYYY")} (
				{smtTime} SMT on {moment(smtDate, "YYYY-MM-DD").format("DD-MMM-YYYY")})
				at {itemC4_1P1.latitude} | {itemC4_1P1.longitude}
			</h4>
		);
	}

	function renderItemP2() {
		const { changingFrom, changingTo } = itemC4FuelTransition;
		return (
			<h4 className="font-medium uppercase">
				<div>
					Fuel Oil ROB and Sulphur Content at SECA {itemC4EntryExit.entryOrExit}
					:
					<br />
					Changeover fuel from {changingFrom.fuelType} (
					{changingFrom.sulphurContent}%) to {changingTo.fuelType} (
					{changingTo.sulphurContent}%)
					<br />
					<CommaSeparator
						items={itemC4Tanks.tanks.map(
							(tank) => `${tank.selectedTank.tankName} - ${tank.quantity}M³`,
						)}
						customSeperator={<br />}
					/>
				</div>
			</h4>
		);
	}

	function getScrubberInfo() {
		const { date: smtDate, time: smtTime } = itemC4Scrubber;
		const dateTimeLocal = `${smtDate}T${smtTime}:00${record.timeZone}`;
		const utcTime = moment.utc(dateTimeLocal);
		return (
			<h4 className="font-medium uppercase">
				Scrubber {itemC4Scrubber.mode === "start" ? "Started" : "Stopped"} on{" "}
				{utcTime.format("HH:mm")} hrs UTC, {utcTime.format("DD-MMM-YYYY")} (
				{smtTime} SMT on {moment(smtDate, "YYYY-MM-DD").format("DD-MMM-YYYY")})
				at {itemC4Scrubber.latitude} | {itemC4Scrubber.longitude}
			</h4>
		);
	}

	function renderMain() {
		const tableRows = [
			[operationDate, "3-C", "4", `SECA ${itemC4EntryExit.entryOrExit}`],
			[null, null, "-", renderItemP1()],
			[null, null, "-", renderItemP2()],
		];

		if (record.remarks) {
			tableRows.push([null, null, "NOTE", record.remarks]);
		}
		if (props.scrubberInfo) {
			tableRows.push([null, null, "-", getScrubberInfo()]);
		}

		return (
			<ORB3TableRows
				record={record}
				tableRows={tableRows}
				theme={props.theme}
			/>
		);
	}

	return renderMain();
}

function mapStateToProps(store: IStore) {
	const vesselStore = vesselSelectors._getStore(store);
	const scrubberInfo = vesselSelectors.getORB3ScrubberInfo(vesselStore);

	return {
		scrubberInfo,
	};
}

const reduxConnector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(ORB3GroupC4_1Preview);
